<template>
  <div class="font-serif text-2xl"><slot /></div>
</template>

<script>
export default {
  name: 'BaseSectionHeader',
};
</script>

<style lang="css" scoped>
</style>
